import { Link } from 'react-router';

export function getRecordingUrl(permalink: string) {
    return <Link to={`/recordings/${permalink}`}>link</Link>;
}
